<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin: 20px;text-align: right;font-weight: bold;font-size:16px;margin-right: 30px;cursor: pointer;"
          @click="backToHome()">
          <返回 </div>


            <div
              style="padding: 10px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
              <div>
                <div style="text-align: center;margin: 5px;font-size:22px;">高级自评表</div>
                <div style="text-align: center;margin: 5px;font-size:16px;color:red;">(更多设置请用微信小程序操作)</div>
              </div>
              <div style="width: 70%;padding:40px;border: 1px solid lightgray;">
                <div style="margin-left: 20px;margin-top: 20px;">
                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分表名称：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
                    </div>
                    <div>
                      <input v-model="form_name" placeholder="输入打分表名称" style="width: 400px;;" />
                    </div>
                  </div>


                  <!--                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分范围：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
                    </div>
                    <div style="font-size: 14px;">
                      最低分：<el-input-number v-model="min_value"></el-input-number>~最高分： <el-input-number
                        v-model="max_value"></el-input-number>
                    </div>
                  </div> -->

                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分指标：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
                    </div>
                    <div style="font-size: 14px;border: 1px solid lightgray;padding:20px;">
                      <div v-for="(item,index) in quotas" :key="index" style="margin-bottom: 10px;">
                        <div style="display: flex;justify-content: space-between;"><span
                            style="font-weight: bold;font-size: 16px;"><img src="../assets/square.png"
                              style="width: 10px;height:10px;margin-right: 5px;" />{{item.quota_name}}（{{item.min_value}}~{{item.max_value}}分）</span>

                          <span>
                            <span
                              style="color:red;text-decoration: underline;font-size: 14px;cursor: pointer;margin:5px;"
                              @click="deleteQuota(item,index)">删除指标</span><span
                              style="color:red;text-decoration: underline;font-size: 14px;cursor: pointer;margin:5px;"
                              @click="editQuota(item,index)">修改指标</span>
                          </span>


                        </div>
                        <div style="margin-top:10px;margin-left: 10px;">
                          <div style="width: 100%;color:gray;">{{item.quota_comment}}</div>
                        </div>
                      </div>
                      <div @click="addQuota"
                        style="text-align: right;font-weight: bold;text-decoration: underline;cursor: pointer;">添加指标
                      </div>

                    </div>
                  </div>

                  <div style="margin-bottom: 30px;">
                    <div
                      style="font-size: 16px;font-weight: bold;margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;">
                      <span>自评人名单：<span
                          style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span></span>
                      <span>
                        <span style="font-weight: bold;text-decoration: underline;cursor: pointer;margin-right: 40px;"
                          @click="importExcelUsers">导入Excel文件中名单</span>
                        <span style="font-weight: bold;text-decoration: underline;cursor: pointer;"
                          @click="importScoreUsers">导入预存名单</span></span>
                    </div>
                    <div>
                      <textarea v-model="score_user_content" maxlength="-1" rows="10" style="width: 100%;"></textarea>
                    </div>
                  </div>

                  <!--                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      <el-checkbox-group v-model="forbid_decimal_checked_state" @change="forbidDecimalChange">
                        <el-checkbox :label="1"><span
                            style="font-size: 16px;font-weight: bold;">打分不允许出现小数</span></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div> -->

                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      咨询电话：
                    </div>
                    <div>
                      <input v-model="contact_phone" placeholder="打分咨询电话" style="width: 400px;;" />
                    </div>
                  </div>


                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分注意事项：
                    </div>
                    <div>
                      <textarea v-model="form_comment" maxlength="-1" rows="10" style="width: 100%;"></textarea>
                    </div>
                  </div>

                </div>


              </div>

              <div style="display: flex;justify-content: center;margin-top: 10px;margin-bottom: 40px;">

                <el-button size="medium" type="primary" style="width: 400px;" @click="saveForm()">立即保存</el-button>
              </div>

            </div>
      </el-col>
    </el-row>

    <!--添加或修改分组-->
    <el-dialog title="打分指标" :close-on-click-modal="false" :visible.sync="quotaDialogVisible" width="40%">
      <div>
        <div style="margin-top: 10px;">
          <div style="margin-bottom: 30px;">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
              指标名称：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
            </div>
            <div>
              <input v-model="quota_name" placeholder="输入指标名称" style="width: 400px;;" />
            </div>
          </div>

          <div style="margin-bottom: 30px;">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
              打分范围：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
            </div>
            <div style="font-size: 14px;">
              最低分：<el-input-number v-model="min_value"></el-input-number>~最高分： <el-input-number
                v-model="max_value"></el-input-number>
            </div>
          </div>


          <div style="margin-bottom: 30px;">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
              指标说明：
            </div>
            <span style="font-size: 18px;">
              <textarea maxlength="-1" rows="8" v-model="quota_comment" placeholder="指标说明"
                style="font-size:18px;width: 80%;" /></span>
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="quotaDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveQuota">保存</el-button>
      </div>

    </el-dialog>



    <!--导入预设名单-->
    <el-dialog title="导入预设名单" :close-on-click-modal="false" :visible.sync="importScoreUserGroupDialogVisible"
      width="40%">
      <div>
        <div style="margin-top: 10px;">
          <div>
            <el-select @change="selectGroup" v-model="seleced_group" placeholder="请选择">
              <el-option v-for="item in groups" :key="item.group_name" :label="item.group_name"
                :value="item.group_name">
              </el-option>
            </el-select>
          </div>

          <div style="margin-top: 20px;">
            <el-input type="textarea" rows="10" placeholder="请输入内容" v-model="selected_user_names" />
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="importScoreUserGroupDialogVisible = false">取消</el-button>
        <el-button @click="insertScoreUsers()" type="primary">导入名单</el-button>
      </div>

    </el-dialog>








  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        form_id: '',
        form_name: '',
        min_value: 0,
        max_value: 100,
        score_user_content: '',
        form_comment: '',
        contact_phone: '',
        quotas: [],

        quotaDialogVisible: false,
        quota_name: '',
        quota_comment: '',


        importScoreUserGroupDialogVisible: false,
        groups: [],
        seleced_group: '',
        selected_user_names: '',

        forbid_decimal: '0',
        forbid_decimal_checked_state: false,


        current_quota_index: -1

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session

      this.form_id = this.$route.params.form_id


      if (!Utils.isEmpty(this.form_id)) {
        this.loadScoreFormEx()
      }

      this.loadGroups() //导入用户
    },
    methods: {
      forbidDecimalChange() {
        // console.log(this.forbid_decimal)
        if (this.forbid_decimal_checked_state == true) {
          this.forbid_decimal = '1'
        } else {
          this.forbid_decimal = '0'
        }

        console.log(this.forbid_decimal)
      },
      loadGroups() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_load_user_groups.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username
            }
          }).then(function(response) {
            that.groups = response.data.user_group_list

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      selectGroup(e) {
        console.log(e)
        // this.selected_user_names=e

        for (var i = 0; i < this.groups.length; i++) {
          var gName = this.groups[i].group_name

          if (gName == e) {
            this.selected_user_names = this.groups[i].name_str
            break
          }
        }
      },
      insertScoreUsers() {
        this.score_user_content = this.selected_user_names
        this.importScoreUserGroupDialogVisible = false
      },
      importScoreUsers() {
        this.importScoreUserGroupDialogVisible = true
      },
      buildNameArray(content_str) {
        var tmpNameStr = content_str.trim()

        let tmpList = []
        let names = []

        tmpList = tmpNameStr.split(/[\n]/)


        var tStr = ''

        for (var i = 0; i < tmpList.length; i++) {
          if (!Utils.isEmpty(tmpList[i])) {
            var str = tmpList[i]
            str = str.trim()

            names.push(str)
          }
        }

        return names
      },
      saveForm() {
        if (Utils.isEmpty(this.form_name)) {
          this.$message.error('请输入打分表名称!')
          return
        }

        if (this.quotas.length == 0) {
          this.$message.error('请输入打分指标!')
          return
        }

        if (Utils.isEmpty(this.score_user_content)) {
          this.$message.error('请输入自评人员名单!')
          return
        }



        let that = this

        var qs = require('qs')



        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var score_quota_name = '自评得分'
        var tmpArray = this.distinct(this.buildNameArray(this.score_user_content))
        var score_users_json_str = JSON.stringify(tmpArray)

        var quotas_json = JSON.stringify(this.quotas)

        let data = {
          form_id: that.form_id,
          form_name: that.form_name,
          form_comment: that.form_comment,
          score_users: score_users_json_str,
          // start_time: that.start_time,
          // end_time: that.end_time,
          contact_phone: that.contact_phone,
          equipment: that.username,
          score_quota_name: score_quota_name,
          min_value: that.min_value,
          max_value: that.max_value,
          quotas: quotas_json,
          forbid_decimal: that.forbid_decimal
        }

        var requestUrl = '/evaluations/web/_save_self_single_quota_form_ex.jsp'
        this.axios.post(requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            load.close()
            that.$message('保存成功')

            that.$router.push('/form_list')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      backToHome() {
        this.$router.go(-1)
      },
      addQuota() {
        this.quotaDialogVisible = true
      },
      saveQuota() {
        if (Utils.isEmpty(this.quota_name)) {
          this.$message.error('请输入指标名称!')
          return
        }







        if (this.current_quota_index < 0) {


          //判断指标是否存在
          var isDuplicatedQuota = false
          var tmpQuotas = this.quotas
          for (var i = 0; i < tmpQuotas.length; i++) {
            if (tmpQuotas[i].quota_name == this.quota_name) {
              isDuplicatedQuota = true
              break
            }
          }
          if (isDuplicatedQuota == true) {
            this.$alert('该指标已经存在！')
            return
          }



          let that = this
          let quota = {
            quota_name: that.quota_name,
            quota_comment: that.quota_comment,
            min_value: that.min_value,
            max_value: that.max_value
          }

          this.quotas.push(quota)
          this.quotaDialogVisible = false

          this.quota_name = ''
          this.quota_comment = ''

        } else {

          //判断指标是否存在
          var isDuplicatedQuota = false
          var tmpQuotas = this.quotas
          for (var i = 0; i < tmpQuotas.length; i++) {
            if (tmpQuotas[i].quota_name == this.quota_name && this.current_quota_index != i) {
              isDuplicatedQuota = true
              break
            }
          }
          if (isDuplicatedQuota == true) {
            this.$alert('该指标已经存在！')
            return
          }


          this.quotas[this.current_quota_index].quota_name = this.quota_name
          this.quotas[this.current_quota_index].quota_comment = this.quota_comment
          this.quotas[this.current_quota_index].min_value = this.min_value
          this.quotas[this.current_quota_index].max_value = this.max_value
          this.quotaDialogVisible = false
          this.quota_name = ''
          this.quota_comment = ''
          this.current_quota_index = -1


        }

      },
      deleteQuota(item, index) {

        let that = this
        this.$confirm('确定要删除此指标吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let tmpArray = []
          for (var i = 0; i < that.quotas.length; i++) {
            if (that.quotas[i].quota_name != item.quota_name) {
              tmpArray.push(that.quotas[i])
            }
          }

          that.quotas = tmpArray

        }).catch(() => {

        })


      },
      editQuota(item, index) {

        this.current_quota_index = index

        this.quota_name = this.quotas[index].quota_name
        this.quota_comment = this.quotas[index].quota_comment
        this.min_value = this.quotas[index].min_value
        this.max_value = this.quotas[index].max_value

        this.quotaDialogVisible = true


      },
      importExcelUsers() {
        this.$alert('打开Excel文件，复制姓名列，直接粘贴到下面的框中即可。', '导入Excel中的姓名', {
          confirmButtonText: '知道了',
          callback: action => {}
        });
      },
      distinct(list) {
        let result = [list[0]]; // 用于承接没有重复的数据，初始时将原始数组的第一个值赋给它。
        for (let i = 1; i < list.length; i++) {
          // 判断结果数组中是否存在一样的值，若果没有的话则将数据存入结果数组中。
          if (!(result.some(val => list[i] === val))) {
            result.push(list[i]);
          }
        }
        return result;
      },
      loadScoreFormEx() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_load_self_score_form_ex.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(resp) {

            load.close()

            console.log(resp.data)

            if (resp.data.result == '1') {
              that.form_name = resp.data.form.form_name
              that.contact_phone = resp.data.form.contact_phone
              that.form_comment = resp.data.form.form_comment
              // that.min_value = resp.data.score_field.min_value
              // that.max_value = resp.data.score_field.max_value

              //打分人
              var tmpScoreUsers = resp.data.score_users
              var tmpScoreUserContent = ''
              for (var i = 0; i < tmpScoreUsers.length; i++) {
                if (i == 0) {
                  tmpScoreUserContent = tmpScoreUsers[i].score_user
                } else {
                  tmpScoreUserContent = tmpScoreUserContent + '\n' + tmpScoreUsers[i].score_user
                }
              }
              that.score_user_content = tmpScoreUserContent

              that.quotas = []
              var tmpQuotas = resp.data.quotas
              for (var i = 0; i < tmpQuotas.length; i++) {
                let quota = {
                  quota_name: tmpQuotas[i].field_name,
                  quota_comment: tmpQuotas[i].field_comment,
                  min_value: tmpQuotas[i].min_value,
                  max_value: tmpQuotas[i].max_value
                }

                that.quotas.push(quota)
              }


              // console.log('ffffffffffff',that.quotas)

              that.$forceUpdate()

            }


          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      }


    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/self_score_form_creater_ex.vue